import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { postFiles } from "@request/client";
import { getQueryParams } from "@request/helpers";

export type OrderPayoutRequest = PaginationParameters<{
  status?: string;
  date_from?: number;
  date_to?: number;
  order_by?: string;
  sort_dir?: string;
  min_sum?: number;
  max_sum?: number;
  method?: string;
  bank?: string;
  my_orders?: boolean;
}>;

export type OrderPayout = {
  AssignedToTraderTime?: string;
  AssignedToTraderTimeUnix?: number;
  trader_files?: string[];
  bank: string;
  closed_time?: string;
  closed_time_unix?: number;
  commission: number;
  created_at: string;
  created_at_unix: number;
  ern_usdt: number;
  ern_rub: number;
  exchange_rate: number;
  full_name: string;
  id: string;
  method: string;
  requisite: string;
  status: string;
  sum: number;
  sum_usdt: number;
};

export type OrderPayoutResponse = PaginationResponse<{
  user_pay_out_order: OrderPayout[];
}>;

export const getPayoutOrdersApi = async (
  userId: string,
  data: OrderPayoutRequest
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<OrderPayoutResponse>({
      url: `api/v1/users/orders-pay-out/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getPayoutOrdersApi failed:", error);
    throw error;
  }
};

export const applyOrderForPayoutApi = async (orderId: string) => {
  try {
    const response = await fetchData<string>({
      method: "POST",
      url: `api/v1/users/apply-for-pay-out/${orderId}`,
    });

    return response;
  } catch (error) {
    console.error("ApplyOrderForPayoutApi failed:", error);
    throw error;
  }
};

export type PayOutUploadResponse = {
  message: string;
  urls: string[];
};

export const uploadReceiptApi = async (orderId: string, files: FileList) => {
  try {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("media_files", files[i]);
    }
    const response = await postFiles<PayOutUploadResponse>({
      method: "POST",
      url: `api/v1/users/pay-out/media/orders/${orderId}`,
      data: formData,
    });

    return response;
  } catch (error) {
    console.error("uploadReceiptApi:", error);
    throw error;
  }
};

export type PayOutReviewRequest = {
  order: string;
  message: string;
  images: string[];
};

export const payOutOrderReviewApi = async (
  data: PayOutReviewRequest,
) => {
  try {
    const response = await fetchData<string>({
      method: "POST",
      url: `api/v1/users/pay-out/orders/under-review`,
      data: data
    });

    return response;
  } catch (error) {
    console.error("payOutOrderReviewApi failed:", error);
    throw error;
  }
};

export type PayOutCancelRequest = {
  order: string;
  comment: string;
  images: string[];
};

export const cancelPayOutOrderApi = async (
  orderId: string,
  data: PayOutCancelRequest,
) => {
  try {
    const response = await fetchData<string>({
      method: "PUT",
      url: `api/v1/users/pay-out/canceled/orders/${orderId}`,
      data: data
    });

    return response;
  } catch (error) {
    console.error("cancelPayOutOrderApi failed:", error);
    throw error;
  }
};
